import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@mui/styles'
import { List as ListIcon, Apps as AppsIcon } from '@mui/icons-material';
import styles from './styles';
import { withRouter } from "common/utils/router.util";

const DisplayMode = ({ classes, className, mode = 'grid', onChange = () => {} }) => {

  const rootClassName = classNames(classes.root, className);

  return (
    <div className={rootClassName}>
      <span
        className={classNames({
          [classes.option]: true,
          [classes.optionSelected]: mode === 'grid'
        })}
        onClick={onChange}
      >
        <AppsIcon className={classes.displayIcon} />
      </span>
      <span className={classes.divider} />
      <span
        className={classNames({
          [classes.option]: true,
          [classes.optionSelected]: mode === 'list'
        })}
        onClick={onChange}
      >
        <ListIcon className={classes.displayIcon} />
      </span>
    </div>
  );
};

DisplayMode.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  mode: PropTypes.oneOf(['grid', 'list']),
  onChange: PropTypes.func
};

// defaultProps removed in favor of default parameters

export default withStyles(styles)(DisplayMode);
